import * as React from 'react';
import styled from 'styled-components';
import CloseIcon from '@material-ui/icons/Close';
import useDevice from '../hooks/useDevice';

const ButtonModalClose = ({
  onClick,
  onTouchStart,
  className,
}: ButtonModalCloseTypes) => {
  const [isIpad] = useDevice();
  return (
    <CloseButton
      type="button"
      onPointerEnter={isIpad ? onClick : null}
      onClick={onClick}
      onTouchStart={onClick}
      className={className}
      aria-label="Close"
    >
      <CloseIcon />
    </CloseButton>
  );
};

const CloseButton = styled.button`
  position: absolute;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  margin: 0;
  border: none;
  outline: none;
  background: transparent;
  appearance: none;
  -webkit-appearance: none;
  border-radius: var(--radius-full);
  color: var(--neutral-500);
  cursor: pointer;
  transition:
    background-color var(--motion-fast) var(--ease-standard),
    color var(--motion-fast) var(--ease-standard),
    box-shadow var(--motion-fast) var(--ease-standard);

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    background: var(--neutral-100);
    color: var(--neutral-800);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }

  &:active {
    background: var(--neutral-200);
  }
`;

interface ButtonModalCloseTypes {
  onClick: () => void;
  onTouchStart: () => void;
  className?: string;
}

export default ButtonModalClose;
